module.exports = __webpack_public_path__ + "img/微信扫码305-305.38424033.png";